module.exports = __webpack_public_path__ + "static/img/integration.ccc0cb07.png";